export const getInvitationText = ({ receiverName, createSubprojectURL, ownerName, rewards }) => {
    const buyingOptions = getBuyingOptionsText({
        rewards,
    });

    return `Hei 👋🏼

Bli med på dugnaden til ${receiverName}! Det er en digital dugnad hvor Spleis sender alle produktene direkte hjem til de som kjøper, så du trenger bare å spre ordet for at dugnaden skal lykkes.

For å delta må du:
- Gå inn på linken: ${createSubprojectURL}
- Logge inn eller registrere deg på Spleis
- Legge inn navnet og bildet til deltakeren for å opprette en personlig salgsside - enkelt og greit!
- Dele salgssiden med venner, familie og andre støttespillere

${
    buyingOptions ? buyingOptions : ''
}Alle produktene blir sendt fraktfritt til hele Norge så du kan til og med selge til slekta på andre siden av landet 🇳🇴

Takk for innsatsen, og lykke til med dugnaden!

Hilsen ${ownerName}`;
};

export const getShortedInvitationText = ({ ownerName, receiverName, rewards, isDugnad }) => {
    const buyingOptions = getBuyingOptionsText({
        rewards,
    });

    if (isDugnad) {
        return `Bli med på dugnaden til ${receiverName}! Det er en digital dugnad hvor Spleis sender alle produktene direkte hjem til de som kjøper, så du trenger bare å spre ordet for at dugnaden skal lykkes.

${
    buyingOptions ? buyingOptions : ''
}Alle produktene blir sendt fraktfritt til hele Norge så du kan til og med selge til slekta på andre siden av landet.

Takk for innsatsen, og lykke til med dugnaden!`;
    } else {
        return `Bli med på spleisen til ${ownerName} til inntekt for ${receiverName}. La oss sammen gjøre en forskjell!`;
    }
};

export const getSubprojectInvitationText = ({
    receiverIsOrg,
    receiverName,
    ownerName,
    participantName,
    invitationLink,
    buyingOptionsText,
}) => {
    const title = receiverIsOrg
        ? `Nå er det tid for dugnad i ${receiverName}!`
        : `${receiverName} har invitert deg til dugnad!`;
    return `${title}

Hei ${participantName} 👋
Dette er en digital dugnad hvor Spleis sender alle produktene direkte hjem til de som kjøper, så du trenger bare å spre ordet for at dugnaden skal lykkes.
For å delta må du:
    Gå til ${invitationLink} for å akseptere invitasjonen
    Hvis du vil kan du legge til bilde av deltakeren for å personalisere salgssiden - enkelt og greit!
    Dele salgssiden med venner, familie og andre støttespillere
${
    buyingOptionsText
        ? `
${buyingOptionsText} Alle produktene blir sendt fraktfritt til hele Norge så du kan til og med selge til slekta på andre siden av landet 🇳🇴
`
        : ''
}
Bli med på dugnaden ved å gå til ${invitationLink}

Takk for innsatsen, og lykke til med dugnaden!
Hilsen ${ownerName}`;
};

export const getBuyingOptionsText = ({
    prefix = 'Man kan kjøpe',
    rewards,
    postfix = ' eller donere en valgfri sum. ',
}) => {
    if (rewards?.length > 0) {
        return `${prefix} ${rewards
            .map((r) => r.title?.toLowerCase())
            .sort((a, b) => a.localeCompare(b))
            .join(', ')}${postfix}`;
    }

    return null;
};

export const createUrlFromCreationUUID = ({ uuid, projectId, relative }) => {
    if (uuid) {
        if (relative) {
            return `/bli-deltaker/${projectId}/${uuid.substring(0, uuid.indexOf('-'))}`;
        }
        return `https://spleis.no/bli-deltaker/${projectId}/${uuid.substring(0, uuid.indexOf('-'))}`;
    } else return '';
};

export const getFirstnameOfInvitee = (name) => {
    const indexOfSpace = name.indexOf(' ');
    if (indexOfSpace === -1) {
        return name;
    }
    return name.substring(0, name.indexOf(' '));
};

export const getSubprojectTitle = ({ subproject, isDugnad }) => {
    if (subproject) {
        if (isDugnad) {
            return subproject.anonymous ? 'Min dugnad' : `${subproject.name} sin dugnad`;
        } else {
            return subproject.anonymous ? 'Min side' : `${subproject.name} sin side`;
        }
    } else {
        return null;
    }
};
